export default __webpack_public_path__ + "static/media/cover1.fa074c8e.jpg";